<template>        
    <transition name="modal">
    <div v-if="isActive" class="dialogWrapper" :class="{'is-active': isActive}">
        <div class="modal-overlay" :class="{'has-overlay': hasOverlay}" @click="cancel()"></div>
        <div class="dialog" role="dialog">
              <header class="dialog-header">
                <h3><slot name="title">{{this.$appTitle}} {{this.$appVersion}}</slot></h3>
                <button class="button-close" @click="cancel()"></button>
              </header>        
              <div class="dialog-message">
                  <div class="dialog-message-content">
                    <slot name="message">no message</slot>
                  </div>
              </div>
              <div class="dialog-footer">
                <slot name="buttons">
                    <button @click="action(self, true); close();" modalResult="confirm">
                        <span class="iconify" data-icon="fa-home"></span>
                        Ok</button>
                    <button @click="action(self, false); close();" modalResult="cancel">
                        <span class="iconify" data-icon="fa-home"></span>
                        Отмена</button>
                </slot>
              </div>
          </div>
    </div>
    </transition>
</template>
<script>

 //:class="{'is-active': isActive}"
 //title: {Type: String, default: 'no title'},
//  :class="{'is-active': isActive}"
 //<i class="fas fa-times fa-xs"></i>
//                   <button @click="action(self, true);" modalResult="confirm">Ok</button>
//                  <button @click="action(self, false)" modalResult="cancel">Отмена</button>
export default {
    name: 'simpleDialog',
    props: {
            active: {Type: Boolean, default: false},
            data: {Type: Array, default: []},
            action: {Type: Function, default: null},
            hasOverlay: {Type: Boolean, default: true},            
    },
    data () {
        return {
            visible: false,
            modalState: false,
            self: [],
        }
    },
    
    computed:{        
        isActive(){return this.visible}
    },

    methods:{
        show(){
            console.log('show dialog');
            this.visible = true;
        },        
        onAction(){
//            this.modalState = true;
            this.visible = false;
        },
        close(){
            this.visible = false;
        },
        cancel(){
            console.log('dialog closed by it self');
//            this.modalState = false;
            this.visible = false;
        }
    },

    created(){   
        
       // this.isActive = this.active;        
        console.log('dialog created');
        console.dir('active:' + this.isActive);
    },

    mounted(){
        //this.isActive = this.active;
        this.self = this; 
        console.log('dialog mounted');
        console.dir('active:' + this.isActive);
    }
}
</script>




<style lang="scss" >   
.modal-enter {opacity: 0;}
.modal-leave-active {opacity: 0;}
.modal-enter .dialog,
.modal-leave-active  .dialog {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
  margin-top: -1vh;
}


.dialogWrapper{
     display:none;
     position: absolute;
     top: 0;
     left: 0;
     width:100%;
     height: 100vh;
     z-index: 9999;
     transition: all .2s ease;
    align-items: center;
    justify-content: center;
    
  }
.dialogWrapper.is-active{
    display:flex;
}
  .dialog{
      height: auto;
      width: auto;
      min-width: 200px;
      transform: scaleX(1) scaleY(1);
      z-index: 201;
      overflow: hidden;
      overflow: overlay;
      flex-wrap: wrap;
      background: #fff;
      border: 1px solid #888;
      border-radius: 3px 3px 3px 3px;
      margin: 1rem;
      box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.5);
transition: all .2s ease;
      /* width: 40vw; */ 
      min-width: 25rem;

  } 
  
  .dialog .dialog-header{
    display: flex;
    flex-wrap: nowrap;
    white-space: nowrap;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    align-content: flex-start;
    font-weight: bold;        
    padding: .4rem .6rem;
    border-bottom: 1px solid #e4e4e4;
    background-color: #f2f2f2;
    border-radius: 2px 2px 0px 0px ;
  }
  
  .dialog-header h3{
    flex-grow: 1;
    flex-basis: 10rem;
    margin-right: 1rem;
    max-width: 30rem;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: #444;
    font-weight: 500;
    font-size: .9rem;
    line-height: 1.3rem;  
   }

  .dialog .dialog-header .button-close{
    flex-basis: 1.4rem;
    flex-shrink: 1; 
    flex-grow: 0; 
    border-radius: 290486px;
    border: 1px solid rgba(0,0,0, 0.2);
    background: #e4e4e4;
    width: 1.4rem;
    height: 1.4rem;
    color: #fff;
    margin-left: auto;    
    cursor: pointer;
    outline: none;
    /* user-select: none; */
    padding: 2px;
    position: relative;
    align-self: flex-start;
    display: flex;
    
  }
.dialog .dialog-header .button-close:hover::before,
.dialog .dialog-header .button-close:hover::after{
    background-color: #fff;
}

.dialog .dialog-header .button-close::before{
    height: 2px;
    width: 60%;
    transform: translateX(-50%) translateY(-50%) rotate(45deg);
}

.dialog .dialog-header .button-close::after{
    height: 2px;
    width: 60%;
    transform: translateX(-50%) translateY(-50%) rotate(-45deg);
/*    height: 50%;
    width: 2px;   
    */ 
}

.dialog .dialog-header .button-close::before, .dialog .dialog-header .button-close::after{
    background-color: #aaa;
    content: "";
    display: block;
    padding: 0;
    margin: 0;    
    left: 50%;
    position: absolute;
    top: 50%;
    transform-origin: center center;
    line-height: 1px;
    font-size: 1px;    
}


.dialog .dialog-header .xbutton-close::after{
/*    content: "\F00D"; */
    font-family: 'Font Awesome 5 Free';
    font-weight: 900;
  content:"+";  
    /*transform: translateX(-50%) translateY(-50%); */

    transform:  translateX(-50%) translateY(-50%) rotate(45deg);
    position: absolute;
    font-size: 1.5rem;

}

  .dialog .dialog-header .button-close:hover{
    background: #ff0089;
  }


  .dialog .dialog-message{
    display: flex;
    padding: .4rem 1rem;
    height: auto;
    max-height: 10rem;    
    overflow-y: auto;
  }

  .dialog  .dialog-message .dialog-message-content{
    flex-basis: 20rem;
    flex-grow: 1;
    width: min-content;
  }

  .dialog .dialog-footer{    
    display: flex;    
    flex-wrap: wrap;
    align-items: flex-end;
    justify-content: flex-end;
    align-content: flex-end;
    padding: .5rem .6rem;
    border-top: 1px solid #e4e4e4;
    background-color: #f2f2f2;
    border-radius: 0px 0px 2px 2px;

    /* position: absolute;  bottom: 0; */
  }

.dialog .dialog-footer button:nth-child(1){
  margin: 0;
}

.dialog .dialog-footer button:focus{
    outline-color: green;
    outline-style: solid;
    outline-width: 2px;
}
.dialog .dialog-footer button{
    padding: .4rem 1rem;
    margin: 0 0 0 .3rem;
    cursor: pointer;
    border: 0px solid #e4e4e4;
    border: 1px solid rgba(27,31,35,.2);
    border-radius: 2px;
    user-select: none;
    outline: 1px;
    background: #50c9ba;
    color: white;
  }
  
  .dialog .dialog-footer button:hover{
      background: #4cbfb1;
  }
  
  .dialog .dialog-footer button:active {
    box-shadow: inset 0 1px 4px rgba(0,0,0,.2);
    outline: 2px;
    outline-color: rgba(0,0,0,.2);
  }
  
  
  /* .modal-overlay::before{filter: blur(15px);}  */
  
  .modal-overlay{
       visibility: hidden;
       z-index: 200;
       width: 100%;
       height: 100vh;
       background: rgba(0,0,0, 0.6);
       position: absolute;
       /* display: flex; */
       top:0;
       vertical-align: middle;
       align-items: center;
   }
  
  .modal-overlay.has-overlay{visibility: visible}
  </style>